export function GridIcon(): JSX.Element {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.333008 0V8H8.33301V0H0.333008ZM6.33301 6H2.33301V2H6.33301V6ZM0.333008 10V18H8.33301V10H0.333008ZM6.33301 16H2.33301V12H6.33301V16ZM10.333 0V8H18.333V0H10.333ZM16.333 6H12.333V2H16.333V6ZM10.333 10V18H18.333V10H10.333ZM16.333 16H12.333V12H16.333V16Z" />
    </svg>
  );
}
